var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-image',{staticStyle:{"cursor":"pointer","width":"300px"},attrs:{"src":_vm.src,"lazy":true,"ratio":"3by2"},nativeOn:{"click":function($event){return _vm.imageModal(_vm.src)}}})}
var staticRenderFns = []

export { render, staticRenderFns }